import { render, staticRenderFns } from "./AlonsoTours.vue?vue&type=template&id=27232b6e&"
import script from "./AlonsoTours.vue?vue&type=script&lang=js&"
export * from "./AlonsoTours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports